import { newsData } from '../../../mocks/news';

export default function NewsSection() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold text-brown-600">
            お知らせ
          </h2>
          <a
            href="#news"
            className="text-brown-400 hover:text-brown-500 transition-colors font-serif text-sm md:text-base hover:underline cursor-pointer"
          >
            一覧を見る
          </a>
        </div>
        
        <div className="border-2 border-brown-200 rounded-lg overflow-hidden">
          {newsData.map((news, index) => (
            <article
              key={news.id}
              className={`flex flex-col sm:flex-row items-start sm:items-center gap-4 p-6 hover:bg-cream-50 transition-colors cursor-pointer ${
                index !== newsData.length - 1 ? 'border-b border-brown-200' : ''
              }`}
            >
              <time className="text-brown-400 font-serif text-sm md:text-base whitespace-nowrap">
                {news.date}
              </time>
              <h3 className="text-brown-600 font-serif text-base md:text-lg flex-1">
                {news.title}
              </h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}